// Make sure to run npm install @formspree/react
// For more help visit https://formspr.ee/react-help
import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';

function ContactForm() {
  const [state, handleSubmit] = useForm("xwpqvdjz");
  
  return (
    <Container className='route-container contact-us'>
        <Row>
            <Col><h2>Contact Us.</h2></Col>
        </Row>
        <Row>
        <Col>
            {
                state.succeeded ? <p>Thanks for Reaching out!</p> :
                <form onSubmit={handleSubmit}>
                    <div className='mb-3'>
                        <label htmlFor="email" className="form-label">
                            Email Address
                        </label>
                        <input
                            id="email"
                            type="email" 
                            name="email"
                            className="form-control"
                        />
                        <ValidationError 
                            prefix="Email" 
                            field="email"
                            errors={state.errors}
                        />
                    </div>
                    <div className='mb-3'>
                        <label className="form-label">Message</label>
                        <textarea
                            id="message"
                            name="message"
                            className="form-control"
                            rows={5}
                        />
                        <ValidationError 
                            prefix="Message" 
                            field="message"
                            errors={state.errors}
                        />
                    </div>
                    <div className='mb-3'>
                        <button type="submit" disabled={state.submitting} className='btn'>
                            Submit
                        </button>
                    </div>
    </form>
            }
            
            </Col>
        </Row>
    </Container>
  );
}


export default ContactForm;